<mat-form-field
  class="w-100 green translation-field"
  [class.sm]="fieldOptions.size === 'sm'"
  [class.error]="fieldOptions.control.invalid"
  subscriptSizing="fixed"
  hideRequiredMarker
>
  <mat-label *ngIf="fieldOptions.label">{{ fieldOptions.label }}</mat-label>
  <textarea
    matInput
    cdkAutosizeMaxRows="10"
    cdkAutosizeMinRows="1"
    cdkTextareaAutosize
    [formControl]="fieldOptions.control"
    [placeholder]="fieldOptions.placeholder ?? ''"
  ></textarea>
  <mat-error *ngIf="fieldOptions.requiredTranslationKey && fieldOptions.control.hasError('required')">
    {{ 'RECIPE_TRANSLATION.VALIDATION.REQUIRED' | translate : { field: fieldOptions.requiredTranslationKey } }}
  </mat-error>
</mat-form-field>
